import React, { Component } from "react";
import { TrackingAsesoresStore } from "../../../containers/comisionesMembresiaConfiguracion/trackingAsesores/TrackingAsesores.store";
import { TrackingAsesoresDispatcher } from "../../../containers/comisionesMembresiaConfiguracion/trackingAsesores/TrackingAsesores.dispatcher";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./TrackingAsesores.form";
import CompromisosComponent from "./compromisos";
import AsesoresComponent from "./asesores";
import ActividadesComponent from "./actividades";
import {
  successNotification,
  errorNotification
} from "../../../../utils/notifications";
import { Alert } from "reactstrap";

interface Props extends TrackingAsesoresStore, TrackingAsesoresDispatcher {}

interface State {
  periodo: string;
  mes: number;
  anio: number;
  idClub: number;
  saveKey: number;
}

export default class TrackingAsesoresComponent extends Component<Props, State> {
  state = {
    periodo: null,
    mes: null,
    anio: null,
    idClub: null,
    saveKey: 0
  };

  componentDidUpdate(prevProps: Props) {
    if (
      this.props.membresiaTrackingClubAlcance &&
      this.props.membresiaTrackingClubAlcance !==
        prevProps.membresiaTrackingClubAlcance
    ) {
      this.setState({
        saveKey: this.state.saveKey + 1
      });
    }
  }

  submit = async (values: any) => {
    const { mes, anio, idClub } = values;
    const year = anio || new Date().getFullYear();
    const periodo = `${year}-${mes}-01`;

    this.setState({
      periodo,
      idClub: Number(idClub),
      mes: Number(mes),
      anio: Number(year)
    });

    const preview = await this.props.getTrackingByPeriodoAndClub(
      periodo,
      idClub
    );

    if (preview.fulfilled) {
      successNotification("Tracking cargado correctamente");
    } else {
      errorNotification(preview.gettingMembresiaTrackingClubAlcanceError);
    }
  };

  handleSaveCompromisos = async (
    periodo: string,
    idClub: number,
    compromisos: any
  ) => {
    return await this.props.putCompromisoClub(periodo, idClub, compromisos);
  };

  handleSaveAsesores = async (
    periodo: string,
    idClub: number,
    asesores: any[]
  ) => {
    return await this.props.putAsesoresTracking(periodo, idClub, asesores);
  };

  handleReloadTracking = async (periodo: string, idClub: number) => {
    return await this.props.getTrackingByPeriodoAndClub(periodo, idClub);
  };

  render() {
    const { periodo, idClub, saveKey, mes, anio } = this.state;
    const {
      membresiaTrackingClubAlcance,
      puttingMembresiaTrackingCompromisos,
      puttingMembresiaTrackingAsesores
    } = this.props;

    return (
      <div className="container">
        <Alert color="info" className="mt-3 mb-3">
          Las configuraciones establecidas en esta pantalla son informativas y
          no se considerarán para el cálculo de comisiones.
        </Alert>

        <div style={{ margin: "0 15px" }}>
          <FormBuilder<Inputs, Buttons>
            config={formConfig}
            submit={this.submit}
            processing={this.props.gettingMembresiaTrackingClubAlcance}
          />
        </div>

        {membresiaTrackingClubAlcance && periodo && idClub && (
          <>
            <CompromisosComponent
              periodo={periodo}
              idClub={idClub}
              trackingData={membresiaTrackingClubAlcance}
              saveKey={saveKey}
              puttingCompromisos={puttingMembresiaTrackingCompromisos}
              onSave={this.handleSaveCompromisos}
              onReload={this.handleReloadTracking}
            />

            <div className="mt-4 mb-5">
              <hr />
            </div>

            <AsesoresComponent
              periodo={periodo}
              idClub={idClub}
              trackingData={membresiaTrackingClubAlcance}
              saveKey={saveKey}
              puttingAsesores={puttingMembresiaTrackingAsesores}
              onSave={this.handleSaveAsesores}
              onReload={this.handleReloadTracking}
            />

            <div className="mt-4 mb-5">
              <hr />
            </div>

            <ActividadesComponent
              periodo={periodo}
              idClub={idClub}
              month={mes}
              year={anio}
            />
          </>
        )}
      </div>
    );
  }
}
